export enum FileTypeExtension {
  APPLICATION_PDF = 'application/pdf',
  APPLICATION_OCTET_STREAM = 'application/octet-stream',
  APPLICATION_MSWORD = 'application/msword',
  IMAGE_PNG = 'image/png',
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_JPG = 'image/jpg',
  APPLICATION_WORD = 'application/doc',
  APPLICATION_DOX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  APPLICATION_EXCEL = 'application/vnd.ms-excel',
  APPLICATION_EXCELX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  APPLICATION_POWERPOINT = 'application/vnd.ms-powerpoint',
  APPLICATION_POWERPOINTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  URL = 'url'
}
